import PublicationAnalysisFigure from './PublicationAnalysisFigure';
import PublicationAnalysisMethodNote from './PublicationAnalysisMethodNote';
import { LAND_USES, OVERVIEW_DIAGRAM_KEYS, PUBLICATION_DIAGRAMS, getLandUseOverviewFigure } from '../utils/publicationAnalysis';

const LandUseComparisonPage = () => {
  return (
    <section className="section">
      <div className="container">
        <div className="columns">
          <div className="column is-8">
            <h1 className="title">Land use comparison</h1>
            <p>
              Compare synthesized workshop results across agriculture, forest, and urban land-use contexts.
            </p>
          </div>
        </div>
        <PublicationAnalysisMethodNote />

        {OVERVIEW_DIAGRAM_KEYS.map(diagramKey => {
          const diagram = PUBLICATION_DIAGRAMS[diagramKey];
          const figures = LAND_USES.map(landUse => getLandUseOverviewFigure(landUse, diagramKey));

          return (
            <div className="columns publication-analysis-overview-row mb-5" key={diagramKey}>
              <div className="column is-2">
                <div className="publication-analysis-row-title">
                  <h2 className="title is-5 has-text-white">{diagram.shortTitle}</h2>
                  <p>{diagram.text}</p>
                </div>
              </div>
              {figures.map(figure => {
                return (
                  <div className="column" key={`${diagramKey}-${figure.landUse}`}>
                    <PublicationAnalysisFigure
                      title={figure.landUse}
                      src={figure.src}
                      alt={figure.alt}
                      label={figure.title}
                      comparisonTitle={`${diagram.shortTitle} - land use comparison`}
                      comparisonFigures={figures}
                    />
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default LandUseComparisonPage;
